<script setup>
import { DropdownMenuTrigger } from 'radix-vue'
import { cn } from '@/lib/utils'

/**
 * The class the caller passes has to come last.
 *
 * This used to spread every prop onto the primitive and then set
 * `class="outline-none"` beside it, so the caller's class and the wrapper's
 * were merged in an order nobody controlled — and `outline-none` could win over
 * a caller's focus ring. `cn` puts the caller's classes at the end, where they
 * belong.
 */
const props = defineProps({
  asChild: { type: Boolean, default: false },
  class: { type: null, default: '' },
})
</script>

<template>
  <DropdownMenuTrigger :as-child="props.asChild" :class="cn('outline-none', props.class)">
    <slot />
  </DropdownMenuTrigger>
</template>
